module.exports = __webpack_public_path__ + "static/media/omnifood.c246a310.png";